(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class backToTopButton extends HTMLElement {
    constructor() {
      super();
      this.scrollPos                       = 0;
      this.mdUpBreakpoint                  = window.matchMedia("(max-width: 500px)")
      window.addEventListener('resize', () => { this.watchWindowSize(); });
      window.addEventListener('scroll', () => { this.toggleDisplay();   });
      this.addEventListener('click',    () => { this.onBtnClick();      });
      this.watchWindowSize();
    }

    watchWindowSize() {
      if(this.mdUpBreakpoint.matches) {
        this.classList.add('hidden');
        this.classList.remove('block');
      }
    }

    toggleDisplay() {
      this.scrollPos = window.scrollY;
      if (this.scrollPos > 200 && !this.mdUpBreakpoint.matches) {
        this.classList.add('block');
        this.classList.remove('hidden');
      } else {
        this.classList.add('hidden');
        this.classList.remove('block');
      }
    }

    onBtnClick() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  customElements.define('button-backtotop', backToTopButton);

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	let lastKnownScrollPosition = 0;
	let windowWidth             = 0;
	let ticking                 = false;

	window.addEventListener('DOMContentLoaded', (event) => {
		if ( window.scrollY >= 198 ) {
			imageEl.classList.remove( 'hidden' )
		}
	});

	document.addEventListener( 'scroll', function( evt ) {
		lastKnownScrollPosition = window.scrollY
		windowWidth             = window.innerWidth

		if ( ! ticking ) {
			window.requestAnimationFrame( function() {
				showStickyheaderImage( lastKnownScrollPosition )
				ticking = false
			})

			ticking = true
		}
	})

	function showStickyheaderImage( posY ) {
		
	}

	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.getElementById('shopify-section-header');
			this.headerBounds = {};
			this.currentScrollTop = 0;

			this.onScrollHandler = this.onScroll.bind(this);

			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				requestAnimationFrame(this.reveal.bind(this));
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			this.closeSearchModal();
		}

		reveal() {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}

		reset() {
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			this.disclosures.forEach(disclosure => disclosure.close());
		}

		closeSearchModal() {
			this.searchModal = this.searchModal || this.header.querySelector('details-modal');
			this.searchModal.close(false);
		}
	}

	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-old"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.initModalListeners()
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    initModalListeners(){
      const modalToggles = document.querySelectorAll( '.lifestyle-toggle' )
      const modalClose   = document.querySelector( '.lifestyle-modal__close' )
      const modal        = document.getElementById( 'lifestyle-modal' )

      modalClose.addEventListener( 'click', this.hideLifeStyleModal )
      Array.from( modalToggles ).forEach( toggle => toggle.addEventListener( 'click', this.showLifeStyleModal ) )
      document.addEventListener( 'keydown', event => {
        if ( event.key === 'Escape' && modal.classList.contains( 'is-open' ) ) {
          this.hideLifeStyleModal()
        }
      })
      document.addEventListener( 'click', event => {
        if ( event.target.id === 'lifestyle-modal__overlay' ) {
          this.hideLifeStyleModal()
        }
      })
    }

    showLifeStyleModal(){
      const imgURL       = this.dataset.image
      const modal        = document.getElementById( 'lifestyle-modal' )
      const modalContent = document.getElementById( 'lifestyle-modal-content' )
      const modalImg     = `<img src="${ imgURL }" class="lifestyle-modal__image">`
      
      modalContent.insertAdjacentHTML( 'beforeend', modalImg )
      modal.classList.add( 'is-open' )
      modal.setAttribute( 'aria-hidden', false )
    }
    
    hideLifeStyleModal(){
      const modal        = document.getElementById( 'lifestyle-modal' )
      const modalContent = document.getElementById( 'lifestyle-modal-content' )
      
      modal.classList.remove( 'is-open' )
      modal.setAttribute( 'aria-hidden', true )
      modalContent.innerHTML = ""
    }
  }
  
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
